import { render, staticRenderFns } from "./ResultsGrid.vue?vue&type=template&id=66a46766&"
import script from "./ResultsGrid.vue?vue&type=script&lang=js&"
export * from "./ResultsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResultsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports